import axios from "axios";
import { env } from "../../../../env";
import { v4 as uuidv4 } from "uuid";

export const LOGIN_URL = `${env.REACT_APP_API_URL}/api/login`;
export const REGISTER_URL = "api/user/register";
export const REQUEST_PASSWORD_URL = "api/user/forgot-password";
export const ME_URL = `${env.REACT_APP_API_URL}/api/user/me`;

export function login(username, password, requestVerificationToken) {
  const params = { username, password, requestVerificationToken };

  let objJsonStr = JSON.stringify(params);

  let objJsonB64 = Buffer.from(objJsonStr).toString("base64");

  return axios
    .post(
      LOGIN_URL,
      { encryptedData: objJsonB64 },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": document.getElementsByName("csrf-token")[0].content,
        },
      }
    )
    .catch((error) => {
      if (error.response) {
        console.log("test", error.response);
        return error.response;
      } else if (error.request) {
        console.log("test2");

        console.log(error.request);
      } else {
        console.log("test3");

        console.log(error.message);
      }
    });
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}
